import React, { useEffect, useState } from 'react';
import { Modal, Button, Select, MenuItem, FormControl, InputLabel, Checkbox, FormControlLabel } from '@mui/material';
import { useUser } from '../contexts/UserContext';
import { useAccesos } from '../contexts/AccesosContext';

const OpcionesTicket = ({ open, onClose }) => {
  const server = process.env.REACT_APP_API_ROUTE;
  const key = process.env.REACT_APP_API_KEY;
  const { user } = useUser();
  const { userTickets, setUserTickets } = useUser();
  const { tienePermiso } = useAccesos();
  const [idPersonal, setIdPersonal] = useState(null);
  const [idSucursal, setIdSucursal] = useState(''); // Sucursal seleccionada
  const [sucursales, setSucursales] = useState([]); // Lista de sucursales

  const [grupos, setGrupos] = useState([]);
  const [ubicaciones, setUbicaciones] = useState([]);
  const [idUbicacionSeleccionada, setIdUbicacionSeleccionada] = useState('');

  const [servicios, setServicios] = useState([]);
  const [serviciosSeleccionados, setServiciosSeleccionados] = useState([]);

  // Cargar datos iniciales
  useEffect(() => {
    if (open && user) {
      console.log(user.idPersonal);
      setIdPersonal(user.idPersonal);
      // Al abrir el modal, cargar las sucursales
      cargarSucursales();
    }
  }, [open]);



  const cargarSucursales = async () => {
    try {
      const res = await fetch(`${server}/tickets/tbl_sucursal`);
      const data = await res.json();
      const sucData = (data.$values || data).filter(s => s.id_empresa === 1);
      console.log(sucData);
      console.log(userTickets);
      setSucursales(sucData);
    } catch (error) {
      console.error('Error al cargar sucursales:', error);
    }
  };

  const obtenerDatosSucursal = async (idSuc) => {
    try {
      // /api/tickets/tbl_grupo/{idSucursal}
      const gruposRes = await fetch(`${server}/tickets/tbl_grupo/bysucursal/${idSuc}`);
      const gruposData = await gruposRes.json();
      console.log(gruposData);
      setGrupos(gruposData.$values || gruposData);

      // /api/tickets/tbl_ubicacion/byIdSucursal/{idSucursal}
      const ubicacionesRes = await fetch(`${server}/tickets/tbl_ubicacion/bySucursal/${idSuc}`);
      const ubicacionesData = await ubicacionesRes.json();
      console.log(ubicacionesData);
      setUbicaciones(ubicacionesData.$values || ubicacionesData);

    } catch (error) {
      console.error(error);
    }
  };

  const handleSucursalChange = (e) => {
    const nuevaSucursal = e.target.value;
    console.log(nuevaSucursal);
    setIdSucursal(nuevaSucursal);

    // Una vez seleccionada la sucursal, obtener grupos y ubicaciones
    if (nuevaSucursal) {
      obtenerDatosSucursal(nuevaSucursal);
    }
  };


  const obtenerDatosIniciales = async () => {
    try {
      // 3. /api/tickets/tbl_grupo/{idSucursal}
      const gruposRes = await fetch(`${server}/tickets/tbl_grupo/${sucursalId}`);
      const gruposData = await gruposRes.json();
      setGrupos(gruposData.$values || gruposData);

      // 4. /api/tickets/tbl_ubicacion/byIdSucursal/{idSucursal}
      const ubicacionesRes = await fetch(`${server}/tickets/tbl_ubicacion/byIdSucursal/${sucursalId}`);
      const ubicacionesData = await ubicacionesRes.json();
      setUbicaciones(ubicacionesData.$values || ubicacionesData);

    } catch (error) {
      console.error(error);
      // Manejo de error
    }
  };

  const handleSeleccionarGrupo = async (idGrupo) => {
    // /api/tickets/tbl_servio/bygrupo/{idgrupo}
    const serviciosRes = await fetch(`${server}/tickets/tbl_servio/bygrupo/${idGrupo}`);
    const serviciosData = await serviciosRes.json();
    console.log(serviciosData);
    setServicios(serviciosData.$values || serviciosData);
  };

  const toggleServicioSeleccionado = (idServicio) => {
    if (serviciosSeleccionados.includes(idServicio)) {
      setServiciosSeleccionados(serviciosSeleccionados.filter(s => s !== idServicio));
    } else {
      setServiciosSeleccionados([...serviciosSeleccionados, idServicio]);
    }
  };

  const handleGuardarAsignacion = async () => {
    try {

      const loginResponseUbicacion = await fetch(`${server}/tickets/tbl_ubicacion/${idUbicacionSeleccionada}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      });
      if (!loginResponseUbicacion.ok) {
        throw new Error('Error al obtener datos de login');
      }
      const loginDataUbicacion = await loginResponseUbicacion.json();

      const putDataUbicacion = {
        id_ubicacion: loginDataUbicacion.id_ubicacion,
        id_sucursal: loginDataUbicacion.id_sucursal,
        nombre_ubicacion: loginDataUbicacion.nombre_ubicacion,
        estado_ubicacion: true,
        activo_ubicacion: true,
      };

      await fetch(`${server}/tickets/tbl_ubicacion/${idUbicacionSeleccionada}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(putDataUbicacion)
      });

      // POST /api/tickets/tbl_personal_ubicacion por cada servicio
      for (const idServicio of serviciosSeleccionados) {
        const dataToPost = {
          id_personal: userTickets.idPersonal,
          id_sucursal: idSucursal,
          id_ubicacion: idUbicacionSeleccionada,
          id_servicios: idServicio
        };
        console.log(dataToPost);
        await fetch(`${server}/tickets/tbl_personal_ubicacion`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(dataToPost)
        });
      }



      const loginResponse = await fetch(`${server}/tickets/tbl_login/${user.codUsuarioTickets}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      });
      if (!loginResponse.ok) {
        throw new Error('Error al obtener datos de login');
      }
      const loginData = await loginResponse.json();

      // Crear un nuevo objeto con solo los campos necesarios
      const putData = {
        id_login: loginData.id_login,
        tipo: loginData.tipo,
        id_personal: loginData.id_personal,
        login: loginData.login,
        pass: loginData.pass,
        activo_login: loginData.activo_login,
        en_linea: true// Agregar el campo en_linea
      };
const idLogin = loginData.id_login;
      console.log(putData);
      // PUT /api/tickets/tbl_login/{id} en_linea=1
      await fetch(`${server}/tickets/tbl_login/${idLogin}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(putData)
      });

      // // PUT /api/tickets/tbl_ubicacion/{idUbicacion}
      // await fetch(`${server}/tickets/tbl_ubicacion/${idUbicacionSeleccionada}`, {
      //   method: 'PUT',
      //   headers: { 'Content-Type':'application/json' },
      //   body: JSON.stringify({ estado_ubicacion:1, activo_ubicacion:1 }) 
      // });

      // asignacion_ticket()
      // await asignacionTicket();
      // Conservar la ubicación seleccionada dentro de userTickets (o creas un “campo” similar)
      setUserTickets((prev) => ({
        ...prev,
        idUbicacionSeleccionada: idUbicacionSeleccionada
      }));

      // Cerramos el modal al final
      onClose();
    } catch (error) {
      console.error(error);
    }
  };

  const asignacionTicket = async () => {
    // /api/tickets/tbl_personal_ubicacion/{idPersonal}/{idUbicacion}
    const personalUbicacionRes = await fetch(`${server}/tickets/tbl_personal_ubicacion/${idPersonal}/${idUbicacionSeleccionada}`);
    const personalUbicacionData = await personalUbicacionRes.json();

    // personalUbicacionData contiene una lista de servicios asignados
    // Por cada servicio ejecuta /api/tickets/tbl_ticket/pendientesbySucursal/{idsucursal}/{idservicio}
    for (const pu of personalUbicacionData.$values || personalUbicacionData) {
      const idServicio = pu.id_servicios; // Ajustar al campo correcto
      const pendientesRes = await fetch(`${server}/tickets/tbl_ticket/pendientesbySucursal/${idSucursal}/${idServicio}`);
      const pendientesData = await pendientesRes.json();

      if (pendientesData.$values && pendientesData.$values.length > 0) {
        const ticket = pendientesData.$values[0]; // Tomar el primero
        const idTicket = ticket.id; // Ajustar a campo correcto

        // PUT /api/tickets/tbl_ticket/tomarticket/{idTicket}
        await fetch(`${server}/tickets/tbl_ticket/tomarticket/${idTicket}`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ idPersonal: idPersonal, llamado: 1 })
        });
      }
    }
  };

  const handleDejarDeAtender = async () => {
    const loginResponseUbicacion = await fetch(`${server}/tickets/tbl_ubicacion/${idUbicacionSeleccionada}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });
    if (!loginResponse.ok) {
      throw new Error('Error al obtener datos de login');
    }
    const loginDataUbicacion = await loginResponseUbicacion.json();

    const putDataUbicacion = {
      id_ubicacion: loginDataUbicacion.id_ubicacion,
      id_sucursal: loginDataUbicacion.id_sucursal,
      nombre_ubicacion: loginDataUbicacion.nombre_ubicacion,
      estado_ubicacion: true,
      activo_ubicacion: true,
    };

    await fetch(`${server}/tickets/tbl_ubicacion/${idUbicacionSeleccionada}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(putDataUbicacion)
    });

    const loginResponse = await fetch(`${server}/tickets/tbl_login/${user.codUsuarioTickets}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });
    if (!loginResponse.ok) {
      throw new Error('Error al obtener datos de login');
    }
    const loginData = await loginResponse.json();

    // Crear un nuevo objeto con solo los campos necesarios
    const putData = {
      id_login: loginData.id_login,
      tipo: loginData.tipo,
      id_personal: loginData.id_personal,
      login: loginData.login,
      pass: loginData.pass,
      activo_login: loginData.activo_login,
      en_linea: false// Agregar el campo en_linea
    };
    const idLogin = loginData.id_login;
    console.log(putData);
    // PUT /api/tickets/tbl_login/{id} en_linea=1
    await fetch(`${server}/tickets/tbl_login/${idLogin}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(putData)
    });
  };


  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '60%',
    maxHeight: '90vh',
    overflowY: 'auto',
    backgroundColor: '#fff',
    padding: '20px',
    boxShadow: 24,
    outline: 'none',
  };

  return (
    <Modal open={open} onClose={onClose}>
      <div style={modalStyle}>
        <h2>Opciones Ticket</h2>

        {/* Combobox Sucursales */}
        <FormControl fullWidth style={{ marginBottom: '10px' }}>
          <InputLabel>Sucursal</InputLabel>
          <Select value={idSucursal} onChange={handleSucursalChange}>
            {sucursales.map(s => (
              <MenuItem key={s.id_sucursal} value={s.id_sucursal}>{s.nombre_sucursal}</MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* Combobox Ubicacion */}
        <FormControl fullWidth>
          <InputLabel>Ubicación</InputLabel>
          <Select value={idUbicacionSeleccionada} onChange={(e) => setIdUbicacionSeleccionada(e.target.value)}>
            {ubicaciones.map(u => (
              <MenuItem key={u.id_ubicacion} value={u.id_ubicacion}>{u.nombre_ubicacion}</MenuItem>
            ))}
          </Select>
        </FormControl>

        <h3>Grupos</h3>
        {/* Lista de grupos */}
        <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
          {grupos.map(g => (
            <Button key={g.id_grupo} variant="contained" onClick={() => handleSeleccionarGrupo(g.id_grupo)}>
              {g.nombre_grupo}
            </Button>
          ))}
        </div>

        <h3>Servicios del Grupo Seleccionado</h3>
        {/* Tabla de servicios con checkboxes */}
        <table>
          <thead>
            <tr>
              <th>Seleccionar</th>
              <th>Servicio</th>
            </tr>
          </thead>
          <tbody>
            {servicios.map(s => (
              <tr key={s.id_servicios}>
                <td>
                  <Checkbox
                    checked={serviciosSeleccionados.includes(s.id_servicios)}
                    onChange={() => toggleServicioSeleccionado(s.id_servicios)}
                  />
                </td>
                <td>{s.descripcion_servicio}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <Button variant="contained" color="primary" onClick={handleGuardarAsignacion} disabled={!tienePermiso('Crear Opción Ticket')}>
          Guardar Asignacion
        </Button>
        {/* <Button
          variant="contained"
          color="error"
          onClick={handleDejarDeAtender}
        >
          Dejar de Atender
        </Button> */}
      </div>
    </Modal>
  );
};

export default OpcionesTicket;
